import { labels } from 'presentation/constant/labels'
import { validateSecretP2p } from 'presentation/utils/format'

export const validateSecretP2pString = (secretKeyP2p: string) => {
  if (secretKeyP2p === '') {
    return labels.form.requiredFieldText
  }
  if (!validateSecretP2p(secretKeyP2p)) {
    return labels.form.wrongDatesText
  }
  return ''
}
